import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { AppProps } from 'presentation/App';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { LuChevronLeft } from 'react-icons/lu';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { RangeData } from '../../CU/CU-056-02/Models/Range';
import { ActionSection } from './components/ActionSection';
import { ConditionSection } from './components/ConditionSection';
import { PriceCard } from './components/PriceCard';
import { ReassureSection } from './components/ReassureSection';
import styles from './styles.module.scss';

const CU05603PageV2 = (_props: AppProps) => {
    const [range, setRange] = useState<RangeData>();
    const [assessmentData, setAssessmentData] = useState<AssessmentSimple>();
    const [stationSelect, setStationSelect] = useState<any>();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userSlice = useAppSelector((state) => state.user);

    useEffect(() => {
        setAssessmentData(location.state?.assessmentData);
        setRange(location.state?.range);
        setStationSelect(location.state?.stationSelect);
    }, []);

    const handleRecalculate = () => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_02}`);
    };

    const handleDetailAssessment = () => {
        if (userSlice?.isSignedIn) {
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_028_01}`);
        } else {
            const confirmProps = {
                message: '以降のステップには\nログインが必要です。',
                okText: 'ログイン・アカウント作成へ',
                cancelText: 'いいえ',
                type: 'info',
                onOk: () => navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`),
            };
            dispatch(showConfirm(confirmProps));
        }
    };

    return (
        <div className={styles.page}>
            <nav className={styles.topNav}>
                <div
                    className={styles.navLeft}
                    onClick={() =>
                        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_01}`)
                    }
                >
                    <LuChevronLeft className={styles.navBackIcon} />
                    <span className={styles.navBackText}>査定メニュー</span>
                </div>
                <h1 className={styles.navTitle}>かんたん査定</h1>
                <div className={styles.navSpacer} />
            </nav>

            <main className={styles.content}>
                {/* Step Progress - both steps active */}
                <div className={styles.progressWrapper}>
                    <div className={styles.progressDots}>
                        <div className={styles.progressDot}>1</div>
                        <div className={styles.progressLine} />
                        <div className={styles.progressDot}>2</div>
                    </div>
                    <div className={styles.progressLabels}>
                        <span className={styles.progressLabel}>情報入力</span>
                        <span className={`${styles.progressLabel} ${styles.progressLabelActive}`}>
                            査定結果
                        </span>
                    </div>
                </div>

                {range && <PriceCard range={range} />}

                {assessmentData && (
                    <ConditionSection
                        assessmentData={assessmentData}
                        stationName={stationSelect?.label}
                        onRecalculate={handleRecalculate}
                    />
                )}

                <ActionSection onDetailAssessment={handleDetailAssessment} />

                <ReassureSection />
            </main>
        </div>
    );
};

export default CU05603PageV2;
